import { STR_FAILURE, STR_SUCCESS } from "core/constants/strings"
import { useAuth } from "core/context/auth"
import useToast from "core/hooks/useToast"
import ProgressMeetAPIDataSourceImpl from "data/API/Student/ProgressMeetAPIDataSourceImpl"
import { ProgressMeetRepositoryImpl } from "data/repository/Student/ProgressMeetRepositoryImpl"
import { ProgressMeetFeedback, ProgressMeetFeedbackExternal } from "domain/model/ProgressMeet"
import { SaveProgressMeetFeedback } from "domain/useCase/Student/ProgressMeet/SaveProgressMeetFeedback"
import { SaveProgressMeetFeedbackExternal } from "domain/useCase/Student/ProgressMeet/SaveProgressMeetFeedbackExternal"
import React from "react"

export default function ProgressMeetFeedbackViewModel() {
  const [openFeedbackModal, setOpenFeedbackModal] = React.useState(true)
  const { toast, changeToastVisibility, changeToastDetails } = useToast()

  const saveProgressMeetFeedbackExternalUseCase = new SaveProgressMeetFeedbackExternal(
    new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl())
  )
  const { auth } = useAuth()

  async function saveProgressMeetFeedback(feedback: ProgressMeetFeedbackExternal) {
    try {
      const response = await saveProgressMeetFeedbackExternalUseCase.invoke(feedback)
      if (!response) {
        changeToastDetails(STR_FAILURE, "Please fill the feedback using your registered email ID only!")
        changeToastVisibility(true)
      } else {
        changeToastDetails(STR_SUCCESS, "Feedback Submitted Successfully")
        changeToastVisibility(true)
      }
    } catch (error) {
      console.error("Failed to save progress meet feedback:", error)
    }
  }
  return {
    saveProgressMeetFeedback,
    openFeedbackModal,
    setOpenFeedbackModal,
    toast,
    changeToastVisibility,
  }
}
